import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AirExpressList from "./AirExpressList";
import AirExpressDetail from "./AirExpressDetail";
import AirExpressOrders from "./AirExpressOrders";
import QuoteRequest from "../Quote/QuoteRequest";

export default function AirExpressPage() {
  return (<Switch>
    <Redirect
      exact={true}
      from="/airexpress"
      to="/airexpress/list"
    />
    <Route
      path="/airexpress/request"
    >
      <QuoteRequest isAirExpress={true}/>
    </Route>
    <Route
      path="/airexpress/orders"
      component={AirExpressOrders}
    />
    <Route
      path="/airexpress/list"
      component={AirExpressList}
    />
    <Route
      path="/airexpress/:id"
      component={AirExpressDetail}
    />
  </Switch>
  );
}
